import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable, throwError } from "rxjs";
import { environment } from "src/app/environments/environment";


@Injectable({
  providedIn: 'root',
})
export class ReportIssueService {

  private apiUrl = environment.baseApiUrl + 'api/ReportIssue/';
  private MN_saveReportIssue: string = 'saveReportIssue';

  clientStudy: any = {
    clientName: '',
    StudyName: '',
    SubStudy: '',
    ModuleName: '',
  }

  constructor(private http: HttpClient) {

  }


  saveReportIssue(clientReportIssue: any): Observable<any> {
    debugger;
    const formData = new FormData();
    formData.append('ClientName', clientReportIssue.client_name);
    formData.append('Description', clientReportIssue.description);
    formData.append('ModuleName', clientReportIssue.module_name);
    formData.append('SelectionSummary', clientReportIssue.selectionSummary);
    formData.append('SnapshotName', clientReportIssue.snapshot_name);
    formData.append('StudyName', clientReportIssue.study_name);
    formData.append('Title', clientReportIssue.title);

    let fileNames:any = [];

    // Append files
    if (clientReportIssue.files && clientReportIssue.files.length > 0) {
      for (let i = 0; i < clientReportIssue.files.length; i++) {
        formData.append('Files', clientReportIssue.files[i]);
        fileNames.push(clientReportIssue.files[i].name);
      }
    }

    formData.append('fileNames', fileNames);

    return this.http.post<any>(`${this.apiUrl}${this.MN_saveReportIssue}`, formData).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Request error:', error);
        // You can handle the error here and throw a custom error if needed
        return throwError((error: any) => new Error(error));
      })
    );
  }
}
